module.exports = "<div class=\"page_loader\">\r\n  <img src=\"assets/img/loader.gif\">\r\n  <p>Please Wait..</p>\r\n</div>"